module.exports = __webpack_public_path__ + "img/pinAmarelo.9872369c.png";